import { ids } from "webpack";
import { getAddOnEnquiry, getFarms, getEnterprises, getFarmers, getSubscriptions, getScheduleCall, getApiUsage, getApiLogs, getContactList, getFeedback, getLeads } from "../../../api/index"
import moment from 'moment';
import { format } from "path";

type SubscriptionStatus = {
  label: string;
  severity: 'critical' | 'urgent' | 'warning' | 'active' | 'expired';
};


const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = date.toLocaleString('en-US', { month: 'short' })
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}

export const farmersData = {
  columns: [
    'Farmer Id',
    'Phone',
    'Email',
    'Created Date',
    'Last Logged In',
    'Is Active',
    'Suspended',
    'Source',
    'Company Id',
    'Country',
    'State',
    'City',
    // 'Contract End Date',   // ← add
    // 'Contract Status',     // ← add
  ]
}
export const fetchFarmersData = async (startDate: string, endDate: string, page: number, sort_by: string, sort_order: string, searchTerm,) => {
  try {
    const response = await getFarmers({ start_date: startDate, end_date: endDate, page, sort_by, sort_order, search: searchTerm });

    if (!response || !response.users) {
      return { totalPages: 0, currentPage: 0, farmers: [] };
    }

    const farmers = response.users.map((user: any) => ({
      FarmerId: user.id || 'NA',
      Phone: user.ph || 'NA',
      Email: user.email || 'NA',
      CreatedDate: user.created_at ? formatDate(user.created_at) : 'NA',
      LastLoggedIn: user.last_login
        ? moment(user.last_login).format('DD-MMM-YYYY HH:mm')
        : 'NA',
      IsActive: user.is_active ? 'Active' : 'Inactive',
      Suspended: user.suspended ? 'Suspend' : 'Unsuspend',
      Source: user.source || 'NA',
      CompanyId: user.company_id || 'NA',
      Country: user.country || 'NA',
      State: user.state || 'NA',
      City: user.city || 'NA',
      // ContractEndDate: user.contract_end_date ? formatDate(user.contract_end_date) : 'NA',  // ← add
      // ContractStatus: user.contract_status || 'NA',                                          
    }));

    return {
      totalPages: response.total_pages,
      currentPage: response.current_page || 0,
      pageSize: response.limit,
      farmers,
    };
  } catch (error) {
    console.error('Error fetching farmer data:', error);
    return { totalPages: 0, currentPage: 0, farmers: [] };
  }
};


export const farmsData = {
  columns: [
    'Farm Id',
    'Farm Name',
    'Farmer Id',
    'Farmer Name',
    'Company Id',
    'Is Paid',
    'Created At',
    'Expiry Date',
    'Area (ac)',
    'Center',
    'Region',
    'Country',
    'State',
    'Status',
  ]
}
export const fetchFarmsData = async (startDate: string, endDate: string, page: number, sort_by: string, sort_order: string, enterpriseId?: string) => {
  try {
    const response = await getFarms({ start_date: startDate, end_date: endDate, page, sort_by, sort_order, enterprise_id: enterpriseId, })
    const data = response.farms
    const farmsData = data.map((farm) => ({
      FarmId: farm.id ?? 'N/A',
      FarmerId: farm.user_id ?? 'N/A',
      CompanyId: farm.company_id ?? 'N/A',
      FarmName: farm.name ?? 'N/A',
      FarmerName: farm.farmer_name?.trim() ? farm.farmer_name : 'N/A',
      Email: farm.email ?? 'N/A',
      PhoneNo: farm.ph ?? 'N/A',
      'Area(ac)': farm.area.toFixed(3) ?? 'N/A',
      Country: farm.country ?? 'N/A',
      State: farm.state ?? 'N/A',
      IsPaid: farm.is_paid ? 'paid' : 'unpaid',
      Center: farm.map_location ?? 'N/A',
      CreatedAt: formatDate(farm.created_at) ?? 'N/A',
      ExpiryDate: farm.expiry_date
        ? moment(farm.expiry_date).format('DD-MMM-YYYY HH:mm')
        : 'N/A',
      Region: farm.region ?? 'N/A',
    }))
    return {
      total_count: response.total_count,
      totalPages: response.total_pages,
      currentPage: response.current_page,
      pageSize: response.limit,
      farmsData,
    };
  } catch (error) {
    console.error("Error fetching farm data:", error)
    return { totalPages: 0, currentPage: 0, farmers: [] };
  }
}



export const enterprises = {
  columns: [
    'Enterprise Id',
    'Enterprise Name',
    'Farms',
    'Farmers',
    'Phone',
    'Total Area (ac)',
    'Is Active',
    'Suspended',
    'Api Key',
    // 'Role',
    'Email',
    'Country',
    'City',
    'State',
    'Postcode',
    'Contract'
    // contract details columns
    // 'Contract Start',      // ← add
    // 'Contract End',        // ← add
    // 'Contract Duration Months', // ← add
    // 'Contract Status',     // ← add
    // 'Change Contract',     // ← add
    // 'Renew Contract',      // ← add
  ],
}
export const fetchEnterprisesData = async () => {
  try {
    const response = await getEnterprises();

    const formattedData = response.enterprises.map((enterprise: any) => ({
      EnterpriseId: enterprise.id || 'N/A',
      EnterpriseName: enterprise.name || 'N/A',
      Farms: enterprise.total_farms || 'N/A',
      Farmers: enterprise.total_farmers || 'N/A',
      Phone: enterprise.ph || 'N/A',     
      Country: enterprise.country || 'N/A',
      ApiKey: enterprise.apikey || 'N/A',
      Email: enterprise.email || 'N/A',
      // Role: enterprise.role || 'N/A',
      IsActive: enterprise.is_active ? 'Active' : 'Inactive',
      City: enterprise.city || 'N/A',
      Suspended: enterprise.suspended ? 'Suspend' : 'Unsuspend',
      State: enterprise.state || 'N/A',
      Postcode: enterprise.postcode || 'N/A',
      //Unit: enterprise.unit || 'N/A',
      'TotalArea(ac)': enterprise.total_farm_area
        ? enterprise.total_farm_area.toFixed(2)
        : 'N/A',

        // Contract details formatting
      ContractStart: enterprise.contract_start_date         // ← add
        ? formatDate(enterprise.contract_start_date)
        : 'N/A',
      ContractEnd: enterprise.contract_end_date             // ← add
        ? formatDate(enterprise.contract_end_date)
        : 'N/A',
      ContractStatus: enterprise.contract_status || 'N/A', // ← add
      ContractDurationMonths: enterprise.contract_duration_months || 'N/A', // ← add

          // Raw dates for modal use — not formatted
      _contractStartRaw: enterprise.contract_start_date || '',   // ← add
      _contractEndRaw: enterprise.contract_end_date || '',       // ← add
      // _contractDurationMonths: enterprise.contract_duration_months || 'N/A', // ← add

    }));
    return formattedData;
  } catch (error) {
    console.error('Error in fetching enterprises data:', error);
    return [];
  }
};

export const SubscriptionData = {
  columns: [
    'Farm Id',
    'Farm Name',
    'Farmer Name',
    'Start Date',
    'End Date',
    'Duration in Days',
    'Days Left',
    'Paid Status',
    'Company Id',
    'Email',
    'Phone',
    'Status',
  ],
}

const calculateDaysLeft = (endDate: string | null): number => {
  if (!endDate) return 0;

  const today = new Date();
  const end = new Date(endDate);

  if (isNaN(end.getTime())) return 0;

  // Normalize to midnight
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const diffTime = end.getTime() - today.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
};

const getSubscriptionStatus = (daysLeft: number): SubscriptionStatus => {
  if (daysLeft <= 0) {
    return { label: 'Expired', severity: 'expired' };
  }

  if (daysLeft <= 7) {
    return { label: `Critical (${daysLeft}d)`, severity: 'critical' };
  }

  if (daysLeft <= 30) {
    return { label: `Urgent (${daysLeft}d)`, severity: 'urgent' };
  }

  if (daysLeft <= 60) {
    return { label: `Expiring Soon (${daysLeft}d)`, severity: 'warning' };
  }

  return { label: `Active (${daysLeft}d)`, severity: 'active' };
};

export const fetchSubscriptionData = async () => {
  try {
    const response = await getSubscriptions();
    console.log('Raw subscription API response:', response);

    const formattedData = response.map((subscription: any) => {
      const daysLeft = calculateDaysLeft(subscription.end_date);
      const status = getSubscriptionStatus(daysLeft);

      return {
        FarmId: subscription.farm_id || 'N/A',
        FarmName: subscription.farm_name || 'N/A',
        FarmerName: subscription.farmer_name || 'N/A',
        StartDate: formatDate(subscription.start_date) || 'N/A',
        EndDate: formatDate(subscription.end_date) || 'N/A',
        DurationinDays: subscription.duration || 'N/A',
        DaysLeft: daysLeft || '0',
        PaidStatus: subscription.is_paid ? 'Paid' : 'Unpaid',
        CompanyId: subscription.company_id || 'N/A',
        Email: subscription.email || 'N/A',
        Phone: subscription.phone || 'N/A',
        Status: status.label || 'N/A',
      };
    });

    return formattedData;
  } catch (error) {
    console.error('Error in fetching subscription data:', error);
    return [];
  }
};


export const enquiry = {
  columns: [
    'Farmer Id', 'Farmer Name', 'Feature', 'Message', 'Email', 'Phone', 'Date', 'Time', 'status',
  ],
};

export const fetchEnquiryData = async () => {
  try {
    const response = await getAddOnEnquiry();
    return response.enquiries.map((item: any, index: number) => {
      const formattedDate = formatDate(item.date);
      return {
        'Farmer Id': item.user_id || 'NA',
        'Farmer Name': item.name || 'NA',
        Feature: item.title || 'NA',
        Message: item.message || 'NA',
        Email: item.email || 'NA',
        Phone: item.ph || 'NA',
        Date: formattedDate || 'NA',
        Time: item.time || 'NA',
        status: item.status || 'NA',

        item_no: item.item_no || 'NA'
      };
    });
  } catch (error) {
    console.error('Error fetching add-on enquiry data:', error);
    return [];
  }
};


export const feedbackData = {
  columns: [
    'Sr No',
    'Name',
    'Message',
    'Email',
    'Phone',
    'Created At'
  ],
}

export const fetchFeedbackData = async (page: number, limit: number) => {
  try {
    const response = await getFeedback({ page, limit });

    if (!response || !response.feedbacks) {
      return { totalPages: 0, currentPage: 0, feedbacks: [] };
    }

    const feedbacks = response.feedbacks.map((feedback: any, index: number) => ({
      SrNo: index + 1,
      Id: feedback.id || "NA",
      Name: feedback.name || "NA",
      Message: feedback.title || "NA",
      Email: feedback.email || "NA",
      Phone: feedback.phone_number || "NA",
      CreatedAt: feedback.created_at
        ? moment(feedback.created_at).format("DD-MMM-YYYY HH:mm")
        : "NA",
    }));

    return {
      totalPages: response.totalPages,
      currentPage: response.currentPage || 0,
      pageSize: response.limit,
      feedbacks,
    };
  } catch (error) {
    console.error("Error fetching feedback data:", error);
    return { totalPages: 0, currentPage: 0, feedbacks: [] };
  }
};


export const scheduledCallsData = {
  columns: [
    'Id',
    'Farmer Name',
    'Phone',
    'Email',
    'How to Contact',
    'Date/Time of Request',
    'Topic',
    'Message',
    'Type of Expert',
    'Status',
  ],
}

export const fetchScheduleCalls = async (startDate: string, endDate: string) => {
  try {
    const response = await getScheduleCall({ start_date: startDate, end_date: endDate });
    return response.calls.map((call: any, index: number) => {
      return {
        'Id': call.id,
        'Farmer Name': call.farmer_name || 'N/A',
        'Phone': call.contact_number || 'N/A',
        Email: call.email || 'N/A',
        'How to Contact': call.how_to_contact || 'N/A',
        'Date/Time of Request': formatDate(call.date_time) || 'N/A',
        Topic: call.topic || 'N/A',
        Message: call.message || 'N/A',
        'Type of Expert': call.type_of_expert || 'N/A',
        Status: call.status || 'N/A',
      }
    })
  }
  catch (error) {
    console.error('Error in fetching schedule calls data:', error);
  }
}


export const APIUsageData = {
  columns: ['Sr No', "User Name", 'API Key', 'Total'],
}
export const fetchAPIusage = async (company_id: string, start_date: string, end_date: string, selectedUsers: any[], selectedApis: any[]) => {
  try {
    const response = await getApiUsage({ company_id, start_date, end_date, user_ids: selectedUsers, apis: selectedApis });

    if (response.data.data.logs.length > 0) {
      const logs = response.data.data.logs;

      // Determine all the possible columns (keys) from the logs
      const allColumns = new Set<string>();
      logs.forEach((log: any) => {
        Object.keys(log).forEach((key) => {
          if (!['api_key', 'company_id', 'username', 'total'].includes(key)) {
            allColumns.add(key);
          }
        });
      });

      // Return the transformed data
      return logs.map((log: any, index: number) => ({
        'Sr No': index + 1,
        "User Name": log.username || 'N/A',
        'API Key': log.api_key || 'N/A',
        Total: log.total || 0,
        ...Array.from(allColumns).reduce((acc: any, column: string) => {
          // If the column doesn't exist for the current user, set it to 0
          acc[column] = log[column] === undefined || log[column] === null ? 0 : log[column];
          return acc;
        }, {}),
      }));
    }

  } catch (error) {
    console.error('Error fetching API usage:', error);
    return [];
  }
};


export const ApiLogsData = {
  columns: [
    'Sr No',
    'Location',
    'Browser',
    'IP Address',
    'Date/Time',
    'Device Type',
    'Status',
    'Message',
    'Email/Phone',
  ],
}
export const fetchAPIlogs = async (api_key: string, api_name: string, start_date: string, end_date: string) => {
  try {
    const response = await getApiLogs({ api_key, api_name, start_date, end_date });
    const apiUsage = response.data.api_usage;

    const formattedData = apiUsage.map((usage: any, index: number) => ({
      SrNo: index + 1,
      Location: usage.location || 'N/A',
      Browser: usage.browser,
      IPAddress: usage.ip_address,
      'Date/Time': usage.created_at
        ? moment(usage.last_login).format('DD-MMM-YYYY HH:mm')
        : 'NA',
      DeviceType: usage.device_type,
      Status: usage.status,
      Message: usage.message,
      'Email/Phone': usage.email || usage.phone || 'N/A',
    }));

    return formattedData;

  } catch (error) {
    console.error('Error fetching farmer data:', error);
    return [];
  }


}

export const ContactUsData = {
  columns: [
    'Id',
    'Name',
    'Email',
    'Phone',
    'Comment',
    'Date',
    'Status'
  ],

}

export const fetchContactData = async (page: number, limit: number) => {
  try {
    const response = await getContactList({ page, limit });

    if (!response || !response.data || !response.data.contacts) {
      return { totalPages: 0, currentPage: 0, contacts: [] };
    }

    const contacts = response.data.contacts.map((contact: any) => ({
      Id: contact.id || 'NA',
      Name: contact.name || 'NA',
      Email: contact.email || 'NA',
      Phone: contact.phone || 'NA',
      Date: contact.created_at ? moment(contact.created_at).format('DD-MMM-YYYY HH:mm') : 'NA',
      Status: contact.status || 'NA',
      Comment: contact.comment || 'NA',
    }));

    return {
      totalPages: response.data.total_pages,
      currentPage: response.data.current_page || 0,
      itemsPerPage: response.data.limit,
      contacts,
    };
  } catch (error) {
    console.error('Error fetching contact data:', error);
    return { totalPages: 0, currentPage: 0, contacts: [] };
  }
}


export const LeadData = {
  columns: [
    'Name',
    'Email',
    'Phone',
    'Status',
    'Assignee',
    'Comment',
    'Type',
    'Created At',
    'Action',
    // 'Plan (if paid)',
    // 'Billing Cycle',
    // 'Purchase History',
  ],

}


export const fetchLeadsData = async (page: number, sort_by: string, sort_order: string,) => {
  try {
    const response = await getLeads({ page, sort_by, sort_order, });

    if (!response || !response.data) {
      return { totalPages: 0, currentPage: 0, leads: [] };
    }

    const leads = response.data.map((lead: any) => ({
      id: lead.id || 'NA',
      Name: lead.name || 'NA',
      Email: lead.email || 'NA',
      Phone: lead.phone || 'NA',
      Status: lead.status || 'NA',
      'Created At': lead.created_at ? formatDate(lead.created_at) : 'NA',
      Type: lead.type || 'NA',
      // Plan: 'NA', // No plan information in the response
      // BillingCycle: 'NA', // No billing cycle information in the response
      // PurchaseHistory: 'NA', // No purchase history in the response
      Comment: lead.comment || 'NA',
      Assignee: lead.assignee_name || 'Unassigned',
    }));

    return {
      totalPages: response.total_pages || 0,
      currentPage: response.current_page || 0,
      pageSize: response.limit || 10,
      leads,
    };
  } catch (error) {
    console.error('Error fetching leads data:', error);
    return { totalPages: 0, currentPage: 0, leads: [] };
  }
};